import { useState, useEffect } from "react";

const CSS_FILES = ["/css/jfk-store.webflow.css", "/css/normalize.css", "/css/webflow.css"];

export const usePageLayout = () => {
  const [layout, setLayout] = useState({ header: "", body: "", footer: "", css: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("user");
    
    if (isLoggedIn) {
      setLoading(false);
      return;
    }

    Promise.all([
      fetch(`${import.meta.env.VITE_API_URL}/home`).then(r => r.json()),
      ...CSS_FILES.map(f => fetch(f).then(r => r.text())),
    ])
    .then(([data, jfkCss, normalizeCss, webflowCss]) => {
      if (window.location.pathname === "/") {
        const existing = document.getElementById("dynamic-page-css");
        if (existing) existing.remove();
        const style = document.createElement("style");
        style.id = "dynamic-page-css";
        style.textContent = normalizeCss + webflowCss + jfkCss;
        document.head.appendChild(style);
      }

      setLayout({
        header: data.data.htmlHeader,
        body: data.data.htmlBody,
        footer: data.data.htmlFooter,
        css: "",
      });
      setLoading(false);
    })
    .catch(() => setLoading(false));

    return () => {
      document.getElementById("dynamic-page-css")?.remove();
    };
  }, []);

  return { layout, loading };
};